import { useState } from 'react';
import CustomerList from './CustomerList';
import CustomerTimeLine from './CustomerTimeline';
function CustomerBooking({ listBooking, formSearch, activeKey, statusFloor, setStatusFloor, refs }: any) {
  const [tab, setTab] = useState<number>(1);
  const renderCustomerBooking = () => {
    if (listBooking?.count_segment === 1 || !listBooking?.schedule?.is_diagram) {
      return (
        <CustomerList
          listBooking={listBooking}
          formSearch={formSearch}
          activeKey={activeKey}
          statusFloor={statusFloor}
          setStatusFloor={setStatusFloor}
          refs={refs}
        />
      );
    } else {
      if (tab === 1) {
        return (
          <CustomerTimeLine
            listBooking={listBooking}
            formSearch={formSearch}
            activeKey={activeKey}
            statusFloor={statusFloor}
            setStatusFloor={setStatusFloor}
            refs={refs}
          />
        );
      } else {
        return (
          <CustomerList
            listBooking={listBooking}
            formSearch={formSearch}
            activeKey={activeKey}
            statusFloor={statusFloor}
            setStatusFloor={setStatusFloor}
            refs={refs}
          />
        );
      }
    }
  };
  return (
    <>
      <>
        {listBooking?.count_segment !== 1 && listBooking?.schedule?.is_diagram ? (
          <div className="tabs-booking-customer d-flex items-center">
            <div className={`tabs-booking-item ${tab === 1 ? 'active' : ''}`} onClick={() => setTab(1)}>
              <span className="tabs-booking-title">Dạng timeline</span>
            </div>
            <div className={`tabs-booking-item ${tab === 2 ? 'active' : ''}`} onClick={() => setTab(2)}>
              <span className="tabs-booking-title">Dạng list</span>
            </div>
          </div>
        ) : (
          ''
        )}
        {renderCustomerBooking()}
      </>
    </>
  );
}
export default CustomerBooking;
